import type {BioIconProps} from './common-types'

function Icon({...attributes}: BioIconProps) {
  return (
    <svg width="116" height="56" viewBox="0 0 116 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g opacity="0.2">
        <path
          d="M52.0874 -1.0587C52.8874 -2.23353 54.7084 -1.85746 54.9775 -0.461771L56.5119 7.49647L64.2921 9.7645C65.6567 10.1623 65.8618 12.0104 64.6176 12.6976L57.5231 16.6161L57.7706 24.7164C57.814 26.1371 56.1196 26.9029 55.0815 25.932L49.1629 20.3958L41.5344 23.134C40.1966 23.614 38.9452 22.24 39.5478 20.9527L42.9833 13.6131L38.0227 7.20476C37.1526 6.0809 38.0723 4.46539 39.4827 4.64042L47.5257 5.64049L52.0874 -1.0587Z"
          fill="#FF9900"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M68.2649 28.1903C69.3243 26.7379 71.6107 27.2879 71.8938 29.0631L73.507 39.1849L83.2489 42.3708C84.9576 42.9295 85.1412 45.2731 83.5403 46.0909L74.4127 50.7536L74.3941 61.0032C74.3907 62.8008 72.2176 63.7001 70.9452 62.4306L63.6901 55.1904L53.9361 58.3395C52.2254 58.8918 50.699 57.1024 51.5135 55.4998L56.1569 46.3626L50.148 38.0592C49.0942 36.6029 50.3235 34.5992 52.0992 34.8785L62.2243 36.4711L68.2649 28.1903Z"
          fill="#FF9900"
        />
      </g>
      <g opacity="0.2" clipPath="url(#clip0_303_5397)">
        <path
          d="M91.2358 1.01458C91.4658 -0.388081 93.2755 -0.815136 94.1081 0.336836L98.8559 6.90547L106.867 5.68045C108.272 5.46561 109.237 7.05469 108.399 8.20261L103.619 14.7477L107.26 21.9879C107.899 23.2578 106.685 24.6668 105.334 24.2243L97.6331 21.7009L91.8712 27.4011C90.8607 28.4006 89.1465 27.6825 89.15 26.2612L89.1693 18.1573L81.9686 14.4391C80.7057 13.7871 80.8582 11.9344 82.2108 11.4983L89.9253 9.01272L91.2358 1.01458Z"
          fill="#FF9900"
        />
      </g>
      <g opacity="0.2" clipPath="url(#clip1_303_5397)">
        <path
          d="M16.2358 22.0146C16.4658 20.6119 18.2755 20.1849 19.1081 21.3368L23.8559 27.9055L31.8668 26.6804C33.2719 26.4656 34.2373 28.0547 33.3991 29.2026L28.6191 35.7477L32.26 42.9879C32.8985 44.2578 31.6852 45.6668 30.3345 45.2243L22.6331 42.7009L16.8712 48.4011C15.8607 49.4006 14.1465 48.6825 14.15 47.2612L14.1693 39.1573L6.96862 35.4391C5.70571 34.7871 5.85825 32.9344 7.21085 32.4983L14.9253 30.0127L16.2358 22.0146Z"
          fill="#FF9900"
        />
      </g>
      <defs>
        <clipPath id="clip0_303_5397">
          <rect width="34" height="34" fill="white" transform="translate(75 -0.191406) rotate(-13.2767)" />
        </clipPath>
        <clipPath id="clip1_303_5397">
          <rect width="34" height="34" fill="white" transform="translate(0 20.8086) rotate(-13.2767)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const StarsGroupIcons = Icon
